import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-community";
import { withFraction32 } from "@/utils/fraction";

const moment = getMomentTz();

export const useBarsTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "Timestamp",
			headerName: "Timestamp",
			valueFormatter: (params) => {
				if (params.value) {
					return moment(params.value).format("MM/DD HH:mm:ss");
				}
				return "";
			},
			flex: 1,
			minWidth: 140,
		},
		{
			field: "BarLength",
			headerName: "Bar Length",
			valueFormatter: (params) => withFraction32(params.value),
			flex: 1,
			minWidth: 100,
		},
		{
			headerName: "Status",
			valueGetter: (params) => {
				if (params.data?.IsTooLong) return "Too Long";
				if (params.data?.IsTooShort) return "Too Short";
				return "";
			},
			flex: 1,
			minWidth: 90,
		},
		{
			field: "CycleMilliseconds",
			headerName: "Cycle (ms)",
			flex: 1,
			minWidth: 90,
		},
		{
			field: "LayerId",
			headerName: "Layer",
			flex: 1,
			minWidth: 70,
		},
	];

	return { columnDefs };
};
